import React, { useContext } from "react";
import { Button } from "reactstrap";
import { AuthContext } from "../context/AuthContext";
import { SUPPORT_TICKET_URL, SUPPORT_PLATFORM } from "../constants";

// Botón "Reportar un problema" del puente de incidencias PSI (helpdesk externo).
// Abre el formulario de reporte en una pestaña nueva, prellenado con los datos
// de sesión del usuario. `platform` identifica el proyecto ante el helpdesk y
// es el único dato de este componente que difiere entre JEDI2 / FastFleet / Propex.
function getMainRoleName(user) {
  const roles = user?.roles || [];
  const mainRole = roles.find((r) => r.mainRole) ?? roles[0];
  return mainRole?.role?.name;
}

function buildReportUrl(auth) {
  const user = auth?.user?.user;
  const name = [user?.firstName, user?.lastName].filter(Boolean).join(" ");

  const params = new URLSearchParams({ platform: SUPPORT_PLATFORM });
  if (name) params.set("name", name);
  if (auth?.user?.email) params.set("email", auth.user.email);
  if (user?.organizationalUnit?.name) {
    params.set("agency", user.organizationalUnit.name);
  }
  const roleName = getMainRoleName(user);
  if (roleName) params.set("role", roleName);

  return `${SUPPORT_TICKET_URL}?${params.toString()}`;
}

export function ReportProblemButton(props) {
  const auth = useContext(AuthContext);

  return (
    <Button
      color="info"
      onClick={() => {
        window.open(buildReportUrl(auth), "_blank", "noopener,noreferrer");
      }}
      {...props}
    >
      Crear Ticket
    </Button>
  );
}

export default ReportProblemButton;